import { render, staticRenderFns } from "./AgentInfo.vue?vue&type=template&id=88dd216e&scoped=true"
import script from "./AgentInfo.vue?vue&type=script&lang=js"
export * from "./AgentInfo.vue?vue&type=script&lang=js"
import style0 from "./AgentInfo.vue?vue&type=style&index=0&id=88dd216e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88dd216e",
  null
  
)

export default component.exports